import { useContext, useMemo } from 'react';
import { useAuth } from '@wix/cli-auth';
import type { CreateHttpClientOptions, HttpClient } from '@wix/cli-http-client';
import { createHttpClient } from '@wix/cli-http-client';
import { HttpClientContext } from './httpClientProvider.js';

export function useHttpClient({
  type,
  siteId,
}: Pick<CreateHttpClientOptions, 'type'> & {
  siteId?: string;
}): HttpClient {
  const context = useContext(HttpClientContext);

  const { getAccessToken: getAppToken, getRequestHeaders: createAuthHeaders } =
    useAuth();

  return useMemo(
    () =>
      createHttpClient({
        type,
        getAppToken: () => getAppToken({ siteId }),
        createHeaders: () => ({
          ...createAuthHeaders?.({ siteId }),
          ...context?.headers,
        }),
      }),
    [type, getAppToken, createAuthHeaders, context, siteId]
  );
}
